// The one floating tooltip the design uses for charts and the map.
import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface TipApi { show(html: ReactNode, x: number, y: number): void; hide(): void }
const Ctx = createContext<TipApi>({ show() {}, hide() {} });
export const useTip = () => useContext(Ctx);


export function TipProvider({ children }: { children: ReactNode }) {
  const el = useRef<HTMLDivElement>(null);
  const [content, setContent] = useState<ReactNode>(null);
  const [on, setOn] = useState(false);
  const show = useCallback((html: ReactNode, x: number, y: number) => {
    setContent(html);
    setOn(true);
    requestAnimationFrame(() => {
      const t = el.current;
      if (!t) return;
      const r = t.getBoundingClientRect();
      let L = x + 14, T = y - r.height - 12;
      if (L + r.width > innerWidth - 8) L = x - r.width - 14;
      if (T < 8) T = y + 16;
      t.style.left = L + 'px';
      t.style.top = T + 'px';
    });
  }, []);
  const hide = useCallback(() => setOn(false), []);
  return (
    <Ctx.Provider value={{ show, hide }}>
      {children}
      {createPortal(<div ref={el} className={'tip' + (on ? ' on' : '')} role="tooltip">{content}</div>, document.body)}
    </Ctx.Provider>
  );
}
